import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadPromotions, getCsvPromotionModel } from '../app/store/actions/promotion';
import UploadFilesComponent from '../components/upload';
import PromotionImportErrors from '../components/upload/PromotionImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadPromotionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadPromotions(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvPromotionModel();
  }

  goBack = () => {
    history.push(ROUTES.PROMOTION);
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importPromotions" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importText1" /></strong></p>
            <p><Translate value="importText2" /></p>
            <p><Translate value="importText3" /></p>
            <p><Translate value="importText4" /></p>
            <p><Translate value="promotionImportText1" /></p>
            <p><Translate value="promotionImportText2" /></p>
            <p><Translate value="promotionImportText6" /></p>
            <p><Translate value="promotionImportText4" /></p>
            <p><Translate value="promotionImportText5" /></p>
            <p><Translate value="promotionImportText3" /></p>
          </div>


          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<PromotionImportErrors errors={errors} />}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadPromotions: file => dispatch(uploadPromotions(file)),
  getCsvPromotionModel: () => dispatch(getCsvPromotionModel()),
});

export default connect(null, mapDispatchToProps)(UploadPromotionsPage);
